module.exports = require('./helpers/bundle-url').getBundleURL('f7fK2') + "logo-dark.eefe0b7f.svg";